module.exports = __webpack_public_path__ + "static/media/analog-quartz-watch.693a42b6.jpg";